import { useReducer } from 'react';

const defaultState = { isOpen: false };

type ActionType = { type: 'open' | 'close' };
type State = typeof defaultState;

const reducer = (state: State, action: ActionType) => {
  switch (action.type) {
    case 'open':
      return { isOpen: true };
    case 'close':
      return { isOpen: false };
    default:
      throw Error('Unknown action.');
  }
};

const useDialogHandler = () => {
  const [state, dispatch] = useReducer(reducer, defaultState);

  const handleOpen = () => dispatch({ type: 'open' });
  const handleClose = () => dispatch({ type: 'close' });

  return [state, handleOpen, handleClose] as const;
};

export { useDialogHandler };
